module.exports = __webpack_public_path__ + "static/media/icon.0c4d1f80.png";